import React, { useState, useEffect } from "react";
import { Mail } from "lucide-react";

export default function ContactIcon({ onContactClick, hidden }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (hidden) return null;

  return (
    <button
      className={`contact-button ${show ? "show" : ""}`}
      onClick={onContactClick}
    >
      <Mail size={20} />
      <span className="tooltip">Formulaire pour nous contacter</span>
    </button>
  );
}
